<mat-toolbar class="small-bar">
  <span>Basic details</span>
  <span class="toolbar-spacer"></span>
  @if (device && device.id && !newItem) {
    <button mat-raised-button color="warn" (click)="deleteDevice()">Eszköz törlése</button>
  }
  <button mat-raised-button color="primary" (click)="saveDevice()" class="ms-2">
    <span translate>SAVE</span>
  </button>
</mat-toolbar>

<div class="container-fluid">
  @if (device) {
    <div class="row mt-3">
      <div class="col-md-3">
        <mat-form-field class="w-100">
          <mat-label>Eszköz neve</mat-label>
          <input type="text" matInput [(ngModel)]="device.name" required>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field class="w-100">
          <mat-label translate>TYPE</mat-label>
          <mat-select [(ngModel)]="device.type" required [compareWith]="compareObjects">
            @for (type of types; track type) {
              <mat-option [value]="type">{{type.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (device.id && !newItem) {
        <div class="col-md-3">
          <mat-form-field class="w-100">
            <mat-label>Módosította</mat-label>
            <input type="text" matInput [(ngModel)]="device.modifiedBy" disabled="disabled" readonly="readonly">
          </mat-form-field>
        </div>
      }
      @if (device.id && !newItem) {
        <div class="col-md-3">
          <mat-form-field class="w-100">
            <mat-label>Módosítva</mat-label>
            <input type="text" matInput [(ngModel)]="device.modified" disabled="disabled" readonly="readonly">
          </mat-form-field>
        </div>
      }
    </div>
  }
</div>

@if (device && device.id && !newItem) {
  <div>
    <mat-toolbar class="small-bar">
      <span>Eszköz tulajdonságok</span>
      <span class="toolbar-spacer"></span>
      <button mat-raised-button (click)="showOldAttributeView = !showOldAttributeView">Régi tulajdonság szerkesztő</button>
      @if (device.type && device.type.attributes) {
        <button class="ms-2" mat-raised-button color="primary" (click)="onSaveAttributeList()" [disabled]="!writeList || !writeList.length">Tulajdonságok mentése</button>
      }
    </mat-toolbar>
    <div class="container-fluid mt-3">
      <div class="row">
        @for (info of allInfo; track info) {
          <div  class="col-md-3">
            <mat-form-field class="w-100 mb-2">
              <mat-label>{{info.attributeName}}</mat-label>
              @if (!info.config || !info.config.options) {
                <input
                  matInput
                  type="text"
                  placeholder="Érték"
                  name="value"
                  maxlength="80"
                  [(ngModel)]="info.value"
                  [maxLength]="info.config && info.config.id && info.config.length ? info.config.length : 1000"
                  (focus)="onInputEditStart(info)"
                  (blur)="onInputEditEnd(info)"
                  >
              }
              @if (!info.config || !info.config.options) {
                <mat-hint>Character limit is: 80</mat-hint>
              }
              @if (info.config && info.config.options) {
                <mat-select
                  [(ngModel)]="info.value"
                  (click)="onInputEditStart(info)"
                  placeholder="Érték"
                  name="value"
                  >
                  @for (o of info.config.options; track o) {
                    <mat-option [value]="o.id" (click)="onInputEditEnd(info)">
                      {{o.name}}
                    </mat-option>
                  }
                </mat-select>
              }
              @if (info.config && info.config.length) {
                <mat-hint>Character limit is: {{info.config.length}}</mat-hint>
              }
            </mat-form-field>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (showOldAttributeView) {
  <div>
    <mat-toolbar class="small-bar">
      <span>Eszközhöz megadott tulajdonságok</span>
      <span class="toolbar-spacer"></span>
      @if (device.type && device.type.attributes) {
        <button mat-raised-button color="primary" (click)="onClickDialogBtn()">Tulajdonság hozzáadása</button>
      }
    </mat-toolbar>
    @if (device && device.infoList.length) {
      <table class="table">
        <thead>
          <tr>
            <th>Tulajdonság</th>
            <th>Érték</th>
            <th>Kezdete</th>
            <th>Vége</th>
            <th>Módosítva</th>
            <th>Módosította</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (info of device.infoList; track info) {
            <tr>
              <td>{{info.attributeName}}</td>
              <td>{{info.value}}</td>
              <td>{{info.start}}</td>
              <td>{{info.end}}</td>
              <td>{{info.modified}}</td>
              <td>{{info.modifiedBy}}</td>
              <td class="text-end">
                <button type="button" mat-raised-button color="warn" (click)="onDeleteInfoClick(info)" >Törlés</button>
                <button type="button" mat-raised-button color="primary" (click)="onEditInfoClick(info)" class="ms-2">Szerkesztés</button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    @if (!device || !device.infoList.length) {
      <p class="text-center p-3">
        Nincs tulajdonság az eszközhöz rendelve.
      </p>
    }
  </div>
}


